import { render } from "./vue-file-preview.vue?vue&type=template&id=67b1cc3c&scoped=true&ts=true"
import script from "./vue-file-preview.vue?vue&type=script&lang=ts"
export * from "./vue-file-preview.vue?vue&type=script&lang=ts"

import "./vue-file-preview.vue?vue&type=style&index=0&id=67b1cc3c&scoped=true&lang=css"

import exportComponent from "../../../../../../../ss/CO/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b1cc3c"]])

export default __exports__